<template>
  <v-col cols="12" v-if="tableDisplay === 'record_requests'">
    <v-row>
      
    </v-row>
  </v-col>
</template>

<script>
  export default {
    name: "RecordRequestsTable",
    props: {
      tableDisplay: String,
    },
  };
</script>

<style></style>
